import { CollectionViewList } from "../../../../../models"


export type SetDocStatusGroup = {type: 'SET_DOCUMENT_STATUS_GROUP', docId: string, toLaneId: number}

export const getUpdatedViewsAfterMove = (lists: CollectionViewList[], docId: string, toLaneId: number): CollectionViewList[] => {
    if(toLaneId === -1) {
        const newLists = lists.map(l => {
            const itemsIds = l.items.map(x => x.documentId)
            if(itemsIds.includes(docId)) {
                l.items = l.items.filter(item => item.documentId !== docId)
                return {
                    ...l,
                    items: l.items.map((l, i) => ({...l, order: i}))
                }   
            }
            return l
        })
        return newLists
    }

    const newLists = lists
    .map(l => {
        const itemsIds = l.items.map(x => x.documentId)
        if(l.id !== toLaneId && itemsIds.includes(docId)) {
            l.items = l.items.filter(item => item.documentId !== docId)
            return {
                ...l,
                items: l.items.map((l, i) => ({...l, order: i}))
            }   
        }

        if(l.id === toLaneId) {
            l.items.push({order: 0, documentId: docId, collectionViewListId: l.id});
            return {
                ...l,
                items: l.items.map((l, i) => ({...l, order: i}))
            }
        }
        return l
    })
    .map((l, i) => ({...l, order: i}))

    return newLists
}